import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Tab, Tabs } from "react-bootstrap";
import { Link, NavLink, useLocation, useParams, useSearchParams } from "react-router-dom";
import { productlisting } from "../../../config/RoutingConsts";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  checkItem,
  produtListDelete,
  removeAllfilter,
  setShopFilter,
} from "../../../Redux/Slices/ProductSlice";
import {
  FILTER_GET_MASTER,
  GET_MAIN_CATEGORY,
  GET_SUB_CATEGORY,
  PRODUCT_LIST,
} from "../../../Redux/SagaAction/actions";
import { userMainCategoryforAPI } from "../../../Redux/Slices/GetCategorySlice";
import { decrypt, encrypt } from "../../../Crypto/function";
import { clearFilterData } from "../../../Redux/Slices/FiltergetSlice";
const HeaderMenu = ({windowWidth,setIsOpen,isOpen}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);
  const { title } = useParams();
  const { mainData, subData } = useSelector(
    (action) => action.GetCategorySlice
  );
  const { pathname } = useLocation();
  const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams()
  const { productsList } = useSelector((state) => state.ProductSlice);
  const { t } = useTranslation();

  const handleSelect = (e) => {
    if (e === active) {
      return;
    }
    setActive(e);
    dispatch(userMainCategoryforAPI(e))
    dispatch(clearFilterData())
    if (!(pathname === "/")) {
      navigate(`/productlisting`,{state: "ALL"});
    }
  };

  useEffect(() => {
    dispatch({
      type: GET_MAIN_CATEGORY,
      callback: (e) => {
        setActive(e);
       dispatch(userMainCategoryforAPI(e))
      },
    });
  }, []); 
  useEffect(() => {
    if (active) {
      dispatch({
        type: GET_SUB_CATEGORY,
        payload: { mainCategoryId: active },
        callback: (e, i) => {
          // if(pathname === "/productlisting"){
          //   dispatch({type:FILTER_GET_MASTER,payload:{
          //         mainCategoryId: e?.[0]?.mainCategoryId
          //        }}) 
          // }
          // if (!(pathname === "/")) {
          //   navigate(`productlisting/${e}`, { state: i });
          // }
        },
      });
      dispatch(produtListDelete())
      // if (pathname === "/") {
      //   dispatch({ type: PRODUCT_LIST, payload: { mainCategoryId: active } });
      // }
    }
  }, [active]);



  
  return (
    <div className="header-menu">
      <Container>
        <div className="header-tab">
          <Tabs onSelect={handleSelect} activeKey={active}>
            {mainData?.map((mList) => {
              return (
                <Tab eventKey={mList?._id} title={mList?.mainCategoryName}>
                  <ul className="menu-list">
                    {subData?.map((list) => {
                      return (
                        <li key={list?.categoryId} onClick={()=> {
                          if(windowWidth < 1199){
                            document.documentElement
                            .querySelector("body")
                            .classList.remove("mobile-open");
                            setIsOpen((e)=>!e)
                          } else{
                            document.documentElement
                            .querySelector("body")
                            .classList.add("mobile-open");
                            // setIsOpen(true)
                          }
                          } }>
                          <Link
                            to={`productlisting/${encrypt(list?.categoryId)}`}
                            className={decrypt(title) === list?.categoryId && "active"}
                            state={list?.categoryName}
                          > 
                            {list?.categoryName.charAt(0).toUpperCase() + list?.categoryName.slice(1).toLowerCase()}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </Tab>
              );
            })}
          </Tabs>
        </div>
      </Container>
    </div>
  );
};
export default HeaderMenu;
